import { deltaReducer as delta } from "./reducer";

export default { delta };
